import { observer } from 'mobx-react-lite';
import { COLORS } from '../../game/data/colors';
import { REWARD } from '../../game/rewardedManager';

export const RewardIndicator: React.FC = observer(() => {
  if (REWARD.reward === null) {
    return null;
  }
  let text = '';
  switch (REWARD.reward) {
    case 'speed':
      text = 'Airplane speed x2';
      break;
    case 'price':
      text = 'Ticket price x2';
  }
  return (
    <div
      style={{
        position: 'absolute',
        top: 100,
        right: 8,
        borderRadius: 4,
        backgroundColor: COLORS.yellow_500,
        padding: '4px 8px',
      }}
    >
      {text}
    </div>
  );
});
